export const AppRoutes = {
  // APP_MONITORING_PAGE: "/monitoring",
  APP_ALARMS_PAGE: "/alarms",
  APP_CONFIGURE_PAGE: "/configure",
  APP_STATISTIC_PAGE: "/statistic",
  APP_CLINICAL_RECORD_PAGE: "/clinical-record",
  APP_LOGIN_PAGE: "/login",
  APP_LOGOUT_PAGE: "/logout",
  APP_OPTIONS_PAGE: "/options",
  APP_LANDING_PAGE: "/home",
  APP_SETUP_PAGE: "/setup",
  APP_RESET_PASSWORD_PAGE: "/reset-password",
  APP_DOMOTICA_PAGE: "/domotica",
  APP_VIDEO_SDK_STREAM_PAGE: "/video-sdk-stream",
  APP_NOT_FOUND_PAGE: "*",
};
